// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListCurrencyConfigQueryVariables = Types.Exact<{
  input: Types.CashierFindCurrencyConfigInput;
}>;


export type ListCurrencyConfigQuery = { __typename?: 'Query', cashier?: { __typename?: 'Cashier', id: string, currencyConfig?: { __typename?: 'CashierCurrencyConnection', edges?: Array<{ __typename?: 'CashierCurrencyEdge', node?: { __typename?: 'CashierCurrencyConfig', id: string, site?: Types.CashierSite, name?: Types.CashierCurrency, type?: Types.CashierCurrencyType, confirmations?: number, maximumFractionDigits?: number, minWithdrawal?: number, minDeposit?: number, isEnabledFlag?: string } }> } } };

export type CurrencyConfigFragment = { __typename?: 'CashierCurrencyConfig', id: string, site?: Types.CashierSite, name?: Types.CashierCurrency, type?: Types.CashierCurrencyType, confirmations?: number, maximumFractionDigits?: number, minWithdrawal?: number, minDeposit?: number, isEnabledFlag?: string };

export type CashierCurrencyEdgeFragment = { __typename?: 'CashierCurrencyEdge', node?: { __typename?: 'CashierCurrencyConfig', id: string, site?: Types.CashierSite, name?: Types.CashierCurrency, type?: Types.CashierCurrencyType, confirmations?: number, maximumFractionDigits?: number, minWithdrawal?: number, minDeposit?: number, isEnabledFlag?: string } };

export const CurrencyConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrencyConfigFragment on CashierCurrencyConfig {
  id
  site
  name
  type
  confirmations
  maximumFractionDigits
  minWithdrawal
  minDeposit
  isEnabledFlag
}
    `;
export const CashierCurrencyEdgeFragmentDoc = /*#__PURE__*/ gql`
    fragment CashierCurrencyEdgeFragment on CashierCurrencyEdge {
  node {
    ...CurrencyConfigFragment
  }
}
    ${CurrencyConfigFragmentDoc}`;
export const ListCurrencyConfigDocument = /*#__PURE__*/ gql`
    query ListCurrencyConfig($input: CashierFindCurrencyConfigInput!) {
  cashier {
    id
    currencyConfig(input: $input) {
      edges {
        ...CashierCurrencyEdgeFragment
      }
    }
  }
}
    ${CashierCurrencyEdgeFragmentDoc}`;
export function useListCurrencyConfigQuery(baseOptions: Apollo.QueryHookOptions<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables> & ({ variables: ListCurrencyConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>(ListCurrencyConfigDocument, options);
      }
export function useListCurrencyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>(ListCurrencyConfigDocument, options);
        }
export function useListCurrencyConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>(ListCurrencyConfigDocument, options);
        }
export type ListCurrencyConfigQueryHookResult = ReturnType<typeof useListCurrencyConfigQuery>;
export type ListCurrencyConfigLazyQueryHookResult = ReturnType<typeof useListCurrencyConfigLazyQuery>;
export type ListCurrencyConfigSuspenseQueryHookResult = ReturnType<typeof useListCurrencyConfigSuspenseQuery>;
export type ListCurrencyConfigQueryResult = Apollo.QueryResult<ListCurrencyConfigQuery, ListCurrencyConfigQueryVariables>;